import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import DataApp from './DataContext';
import AutoLogout from './components/shared/AutoLogout';
import { store } from './store';
import { Provider } from 'react-redux';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
      <Provider store={store}>
      <AutoLogout />
        <DataApp>
          <App />
        </DataApp>
      </Provider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();